export const minQuestions = 5